var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "44px",
    viewBox: "0 0 56 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_List_2995253",
    transform: "translate(-22.000000, 0.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(22.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.2,0.4 L22.7,0.4 C20.3,0.4 18.3,2.4 18.3,4.8 C18.3,7.2 20.3,9.2 22.7,9.2 L51.1,9.2 C53.5,9.2 55.5,7.2 55.5,4.8 C55.6,2.4 53.6,0.4 51.2,0.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2,17.6 L22.7,17.6 C20.3,17.6 18.3,19.6 18.3,22 C18.3,24.4 20.3,26.4 22.7,26.4 L51.1,26.4 C53.5,26.4 55.5,24.4 55.5,22 C55.5,19.6 53.6,17.6 51.2,17.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2,34.8 L22.7,34.8 C20.3,34.8 18.3,36.8 18.3,39.2 C18.3,41.6 20.3,43.6 22.7,43.6 L51.1,43.6 C53.5,43.6 55.5,41.6 55.5,39.2 C55.6,36.7 53.6,34.8 51.2,34.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8,0.4 L4.8,0.4 C2.4,0.4 0.4,2.4 0.4,4.8 C0.4,7.2 2.4,9.2 4.8,9.2 L8.8,9.2 C11.2,9.2 13.2,7.2 13.2,4.8 C13.3,2.4 11.3,0.4 8.8,0.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8,17.6 L4.8,17.6 C2.4,17.6 0.4,19.6 0.4,22 C0.4,24.4 2.4,26.4 4.8,26.4 L8.8,26.4 C11.2,26.4 13.2,24.4 13.2,22 C13.2,19.6 11.3,17.6 8.8,17.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8,34.8 L4.8,34.8 C2.4,34.8 0.4,36.8 0.4,39.2 C0.4,41.6 2.4,43.6 4.8,43.6 L8.8,43.6 C11.2,43.6 13.2,41.6 13.2,39.2 C13.3,36.7 11.3,34.8 8.8,34.8 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebar);
export default __webpack_public_path__ + "static/media/sidebar.1784f5b27cfd962f8000d43ec9b23ead.svg";
export { ForwardRef as ReactComponent };